import React, { FC } from 'react'
import {
  GiftImageCarousel,
  checkFavourited,
  useFavouritesState,
  useHandleFavourite,
} from '@moonpig/web-shared-products'
import { useProductContext } from '../../../contexts/product'
import { ProductModule } from '../types'
import { ProductModuleSection } from '../ProductModuleSection'

export const GiftImageCarouselModule: FC<ProductModule> = props => {
  const [{ product }] = useProductContext()
  const { favourites, location } = useFavouritesState()
  const isFavourited = checkFavourited(favourites, product)

  const handleFavourite = useHandleFavourite({
    tracking: {
      totalCount: 1,
      pageLocation: location,
    },
    removeWithConfirmation: false,
  })

  return (
    <ProductModuleSection {...props}>
      <GiftImageCarousel
        title={product.title}
        id={product.id}
        isFavourited={isFavourited}
        onFavouriteToggle={
          /* istanbul ignore next */ () => {
            handleFavourite(product, isFavourited, 0)
          }
        }
        images={product.masterVariant.images.map(({ url }) => url)}
        productImages={product.masterVariant.productImages?.images}
      />
    </ProductModuleSection>
  )
}
